import { Rating } from "@mui/material";
import axios from "axios";
import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "@mui/material/Button";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Snackbar from "@mui/material/Snackbar";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { AuthContext } from '../../context/AuthContext';
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const SellToolItem = ({ item, onCartUpdate }) => {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [loginDialogOpen, setLoginDialogOpen] = React.useState(false);
  const { user } = React.useContext(AuthContext);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const [tools, setTools] = React.useState([]);
  const Addtocart = async () => {
    if (user == null || user == 'null') {
      setLoginDialogOpen(true);
      return;
    }

    const data = new FormData();
    if (user !== null || user !== 'null') {
      data.append(
        "session", user.SessionId
      );
    }

    data.append("sell_tool_id", item.tool_id);
    const response = await axios.post(
      "https://skillsuprise.com/sell-tool-add-to-cart.php",
      data,
      { header: { "content-type": "multipart/formdata" } }
    );

    if (response) {
      handleClick();
      setOpen(true);
      setMessage(response.data.message);
      if (response.data.status === "success") {
        setTools(response.data.data);
        onCartUpdate();
      }
    }
  };

  const ratingDisplay = React.useMemo(() => (
    <div className="d-flex align-items-center mb-2">
      <Rating
        name="half-rating-read"
        defaultValue={item.tool_rating}
        precision={0.5}
        readOnly
      />
      <span className="">{item.tool_rating}/5 ({item.ratings})</span>
    </div>
  ), [item.tool_rating, item.ratings]);

  return (
    <>
      <div className="d-flex  justify-content-between  align-items-center col-xs-12 col-sm-6 col-12  p-2 col-lg-4 col-xl-3 col-md-6">
        <div
          className="shadow-lg border-0 rounded-4 pb-3 col-12"
          style={{
            background: "#fff",
            padding: "0",
          }}
        >
          <iframe
            height="450"
            className="card-img-top rounded-top-4"
            src={item.youtube_video_link}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
          <div className="card-body p-2">
            <Link to="/details" className="text-decoration-none">
              <h6 className="text-start pb-0 mb-2 text-primary">
                {item.video_title}
              </h6>
            </Link>
            <h6 className="text-danger text-start ps-1 ">
              {" "}
              ₹{item.tool_price}
            </h6>
            {ratingDisplay}

            <div className="d-flex justify-content-between align-items-center ">
              <Button
                onClick={() => Addtocart(true)}
                variant="contained"
                size="large"
                endIcon={
                  <ShoppingCartIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />
                }
                aria-label="Add to cart"
                sx={{
                  height: { xs: 30, sm: 40, lg: 40, xl: 40 },
                  minWidth: { xs: 130, sm: 130, lg: 130, xl: 130 },
                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  padding: { xs: "3px 6px", sm: "4px 8px" },
                  lineHeight: 1.2,
                }}
              >
                Add to Cart 
              </Button>
              <Link to={"/hardware-details/" + item.tool_id}>
                <Button
                  color="success"
                  variant="contained"
                  size="small"
                  endIcon={
                    <ArrowForwardIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />
                  }
                  aria-label="View details"
                  sx={{
                    height: { xs: 30, sm: 40, lg: 40, xl: 40 },
                    minWidth: { xs: 130, sm: 130, lg: 130, xl: 130 },
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    padding: { xs: "3px 6px", sm: "4px 8px" },
                    lineHeight: 1.2,
                  }}
                >
                  View Details
                </Button>

              </Link>
            </div>
          </div>
        </div>

      </div>

      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        message={message}
      />

      <Dialog open={loginDialogOpen} onClose={() => setLoginDialogOpen(false)}>
        <DialogTitle>Login Required</DialogTitle>
        <DialogContent>
          You need to login to add items to cart.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLoginDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setLoginDialogOpen(false);
              window.location.replace('/login');
            }}
            color="primary"
            variant="contained"
          >
            Login
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SellToolItem;
